import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { speciesDto } from 'src/app/models/trofaco/speciesDto';
import { TreeSpeciesService } from '../../core/services/tree-species.service';

@Injectable({
    providedIn: 'root'
})
export class TreeSpeciesResolverService implements Resolve<speciesDto[]> {

    constructor(private treeSpeciesService: TreeSpeciesService) {
    }

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<speciesDto[]> | Promise<speciesDto[]> | speciesDto[] {
        return this.treeSpeciesService.getAllSpecies();
    }
}
